import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, Redirect } from 'react-router-dom';
import { Layout } from 'antd';
import SideMenu from '../components/SideMenu';
import GlobalHeader from '../components/GlobalHeader';
import menuData from '../common/menu';
import { renderRoutes, routerConfig } from '../common/router';

const { Header, Footer, Content } = Layout;

class BasicLayout extends PureComponent {
  static propTypes = {
    currentUser: PropTypes.shape({
      name: PropTypes.string,
    }),
  };

  static defaultProps = {
    currentUser: {},
  };

  render() {
    const { currentUser, location } = this.props;
    const layout = (
      <Layout>
        <SideMenu
          location={location}
          menuData={menuData}
        />
        <Layout>
          <Header style={{ padding: 0 }}>
            <GlobalHeader
              currentUser={currentUser}
            />
          </Header>
          <Content style={{ height: '100%' }}>
            <Switch>
              {renderRoutes(routerConfig)}
              <Redirect path="/" to="/tenant" />
            </Switch>
          </Content>
          <Footer />
        </Layout>
      </Layout>
    );

    return layout;
  }
}

function mapStateToProps({ auth }) {
  return {
    currentUser: auth.user,
  };
}

export default connect(mapStateToProps)(BasicLayout);



// WEBPACK FOOTER //
// ./src/layouts/BasicLayout.js